<template>
  <cv-content-switcher
    class="ff-segmented"
    @selected="actionSelected"
    :size="size">
    <cv-content-switcher-button
      :key="item.value"
      v-for="item in items"
      :owner-id="item.value"
      :class="{'is-selected': initialSelected == item.value}"
      :selected="initialSelected == item.value">
      {{item.text}}
    </cv-content-switcher-button>
  </cv-content-switcher>
</template>

<script>
export default {
  name: 'ff-segmented',
  props: [
    'items',
    'initialSelected',
    'size',
  ],
  data () {
    return {
      selected: null
    }
  },
  computed: {
  },
  methods: {
    actionSelected (value) {
      this.$emit('changed', value)
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .ff-segmented {
    &::v-deep
    .bx--content-switcher-btn {
      text-align: center;
    }
    &::v-deep
    .bx--content-switcher__label {
      @include caps;
      width: 100%;
    }
    &::v-deep
    .bx--content-switcher--selected {
      background: $color-dark;

      .bx--content-switcher__label {
        color: $color-white;
      }
    }
  }

</style>
